import { render, staticRenderFns } from "./CCustomSelectDropdown.vue?vue&type=template&id=cdb75c96&scoped=true&"
import script from "./CCustomSelectDropdown.vue?vue&type=script&lang=ts&"
export * from "./CCustomSelectDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb75c96",
  null
  
)

export default component.exports